import { z } from "zod";
const schemaDeviceCloseParams = z.object({
    transportId: z.string(),
});
const schemaDeviceCloseResults = z.object({
    transportId: z.string(),
});
export const schemaDeviceClose = {
    params: schemaDeviceCloseParams,
    result: schemaDeviceCloseResults,
};
